// frontend/src/components/ui/Card.jsx
// Updated with CSS variables for theming
import React from 'react';
import { cn } from '../../lib/utils';

export const Card = ({ variant = "default", className, ...props }) => {
  const baseClass = "card rounded-lg border shadow-sm";
  const variantClass = variant === "primary" ? "card-primary" : 
                      variant === "secondary" ? "card-secondary" : 
                      "card-default";

  return (
    <div 
      className={cn(
        baseClass,
        variantClass,
        "border border-border-primary bg-background-secondary",
        className
      )} 
      {...props} 
    />
  );
};

export const CardHeader = ({ className, ...props }) => (
  <div className={cn("card-header p-6", className)} {...props} />
);

export const CardTitle = ({ className, children, ...props }) => (
  <h3 className={cn("card-title text-xl font-semibold text-text-primary", className)} {...props}>
    {children}
  </h3>
);

export const CardDescription = ({ className, ...props }) => (
  <p className={cn("card-description text-sm text-text-secondary mt-1", className)} {...props} />
);

export const CardContent = ({ className, ...props }) => (
  <div className={cn("card-content p-6 pt-0", className)} {...props} />
);

export const CardFooter = ({ className, ...props }) => (
  <div className={cn("card-footer flex items-center p-6 pt-0", className)} {...props} />
);